module.exports = __webpack_public_path__ + "static/media/ball_4_0.210dd44d.mp3";